import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['newForm', 'ctaButton', 'emptyState', 'entriesList'];

  connect() {
    this.#sync();
  }

  newFormTargetConnected() {
    this.#sync();
  }

  ctaButtonTargetConnected() {
    this.#sync();
  }

  showNewForm(event) {
    event.preventDefault();
    if (this.hasNewFormTarget) {
      this.newFormTarget.hidden = false;
    }
    this.#sync();
  }

  hideNewForm(event) {
    event.preventDefault();
    if (this.hasNewFormTarget) {
      this.newFormTarget.hidden = true;
    }
    this.#sync();
  }

  #sync() {
    const disabled =
      this.hasNewFormTarget && this.newFormTarget.hidden === false;

    if (this.hasCtaButtonTarget) {
      this.ctaButtonTarget.disabled = disabled;
    }

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.hidden = disabled;

      if (this.hasEntriesListTarget) {
        this.entriesListTarget.hidden = disabled;
      }
    }
  }
}
